import { useContext } from "react";
// Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
// Components
import { useSaveReturn } from "./useSaveReturn";
import { ReturnCancelButton } from "./ReturnCancelButton";
// MUI
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

export const ReturnSubmit = ({ returnData, setActiveStep, setReturnData }) => {
  const { mutate, isSuccess, data } = useSaveReturn();
  const { setAlertNotification } = useContext(AlertNotificationContext);

  const handleBack = () => {
    setActiveStep(1);
  };

  const handleSave = () => {
    mutate({
      data: {
        filter: { noFilter: returnData.data.data.returnOrder.no },
        returnOrder: returnData.data.data.returnOrder,
        returnOrderLines: returnData.data.data.returnOrderLines,
      },
    });
    setActiveStep(3);
  };

  // Success Function
  const successFunc = () => {
    setActiveStep(3);
  };

  // Error Function
  const errorFunc = () =>
    setAlertNotification({
      message: `Error: ${data.data.status}: ${data.data.statusText}`,
      severity: "error",
    });

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <Paper sx={{ p: 2 }}>
      <Stack spacing={1}>
        <Typography variant="h6">
          Submit Return - {returnData.data.data.returnOrder.no}
        </Typography>
        <Typography>
          Please click the submit button below to finalise your return.
        </Typography>
        {/* <Typography>
        Type:{" "}
        {returnData.data.data.returnOrder.dropOff === "Yes"
          ? "Drop Off"
          : "Courier Collection"}
      </Typography> */}
        <Box>
          <Button variant="contained" size="large" onClick={handleSave}>
            Submit
          </Button>
        </Box>
      </Stack>
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          pt: 2,
        }}
      >
        <Button variant="outlined" size="large" onClick={handleBack}>
          Back
        </Button>
        <ReturnCancelButton
          returnData={returnData}
          setReturnData={setReturnData}
          setActiveStep={setActiveStep}
        />
      </Stack>
    </Paper>
  );
};
